import { useState } from 'react';

import { useEnableAiServiceMutation } from '@app/api/AiServices';
import {
  CALL_GRADING_SERVICE_KEY,
  CALL_TRANSCRIPTION_SERVICE_KEY,
} from '@app/pages/PaidAiFeatures/constants/aiServicesDictionary';
import { usePaidAiFeaturesEffects } from '@app/pages/PaidAiFeatures/hooks/usePaidAiFeaturesEffects';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

export const usePaidAiFeatures = () => {
  const { data, isDataLoading, ActiveBranchId } = usePaidAiFeaturesEffects();
  const { showNotification } = useNotification();

  const [enableAiService] = useEnableAiServiceMutation();
  const [togglingKey, setTogglingKey] = useState<string | null>(null);

  const services = data ?? [];

  // Оценка звонка не может работать без транскрипции, поэтому при
  // выключении транскрипции блок оценки блокируется и гаснет визуально.
  const isCallGradingLocked =
    services.find(({ Key }) => Key === CALL_TRANSCRIPTION_SERVICE_KEY)?.IsOn ===
    false;

  const toggleService = (key: string, isOn: boolean) =>
    enableAiService({
      ActiveBranchId: ActiveBranchId as number,
      Key: key,
      IsOn: isOn,
    }).unwrap();

  const handleToggle = async (key: string, isOn: boolean) => {
    if (!ActiveBranchId) return;

    setTogglingKey(key);
    try {
      await toggleService(key, isOn);

      const isTurningOffTranscription =
        key === CALL_TRANSCRIPTION_SERVICE_KEY && !isOn;
      const isCallGradingOn = services.find(
        ({ Key: serviceKey }) => serviceKey === CALL_GRADING_SERVICE_KEY
      )?.IsOn;

      if (isTurningOffTranscription && isCallGradingOn) {
        await toggleService(CALL_GRADING_SERVICE_KEY, false);
      }
    } catch (toggleError) {
      showNotification(handleCatchError(toggleError));
    } finally {
      setTogglingKey(null);
    }
  };

  return {
    services,
    isDataLoading,
    togglingKey,
    isCallGradingLocked,
    handleToggle,
  };
};
